import { Button, ButtonProps } from '@easyv/react-components';
import classNames from 'classnames';
import * as React from 'react';

export type ProButtonProp = ButtonProps & {
  style?: React.CSSProperties;
  className?: string;
  // 禁用tab聚焦
  disableTab?: boolean;
  disabled?: boolean;
};

export function ProButton({ className, disabled, style, disableTab, ...props }: ProButtonProp) {
  return (
    <Button
      disabled={disabled}
      style={style}
      tabIndex={disableTab ? -1 : undefined}
      className={classNames(className, '!leading-5 !flex items-center justify-center')}
      onKeyDown={(event) => {
        if (event.code === 'Space' || event.code === 'Enter' || event.code == 'NumpadEnter') {
          event.preventDefault();
        }
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
}
